export const LOCAL_STORAGE_KEYS = {
  USER_TYPE: "userType",
};

export const LOCAL_STORAGE_VALUES = {
  NORMAL_USER: "normal-user",
};
